import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Proveedor } from "@/shared/types/proveedor";

export async function getProveedor(id: string): Promise<Proveedor> {
    await sleep(1000);
    const response = await api.get("proveedores/" + id);
    return response.data;
}

export function useGetProveedorQuery(id: string, queryConfig: QueryConfig<Proveedor> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getProveedor(id),
        queryKey: ["proveedores", id],
    })
}

export interface GetProveedorQueryProps {
    id: string,
    queryConfig?: QueryConfig<Proveedor>,
    children?: (queryResult: QueryResult<Proveedor>) => ReactNode
}

export function GetProveedorQuery({
    id,
    children,
    queryConfig
}: GetProveedorQueryProps) {
    const queryResult = useGetProveedorQuery(id, queryConfig);
    return children && children(queryResult);
}